export function validateName(name: string): string | null {
  if (!name || name.trim().length === 0) return 'השם דרוש';
  const trimmed = name.trim();
  // Allow unicode letters, spaces, hyphen and apostrophe
  const nameRegex = /^[\p{L}\s'\-]+$/u;
  if (!nameRegex.test(trimmed)) return 'שם מכיל תווים לא חוקיים';

  // basic SQL injection heuristics
  const lowered = trimmed.toLowerCase();
  const suspicious = ['--', ';', '/*', '*/', "@@", 'char(', 'nchar(', 'varchar(', 'alter ', 'drop ', 'insert ', 'delete ', 'update ', 'select '];
  for (const s of suspicious) {
    if (lowered.includes(s)) return 'שם מכיל תווים חשודים';
  }

  if (trimmed.length < 2) return 'השם קצר מדי';
  if (trimmed.length > 100) return 'השם ארוך מדי';
  return null;
}

export function validateEmail(email: string): string | null {
  if (!email || email.trim().length === 0) return 'אימייל דרוש';
  const e = email.trim();
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(e)) return 'אימייל לא חוקי';
  if (e.length > 255) return 'אימייל ארוך מדי';
  return null;
}

export function validatePhone(phone: string, minDigits = 10, maxDigits = 10): string | null {
  if (!phone || phone.trim().length === 0) return 'טלפון דרוש';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < minDigits) return `מספר קצר מדי, יש להכניס לפחות ${minDigits} ספרות`;
  if (digits.length > maxDigits) return `מספר ארוך מדי, יש להכניס עד ${maxDigits} ספרות`;
  if (!/^\d+$/.test(digits)) return 'טלפון צריך להכיל רק ספרות';
  return null;
}

export function validateText(text: string, minLen = 2, maxLen = 1000): string | null {
  if (text === null || text === undefined) return 'שדה דרוש';
  const t = String(text).trim();
  if (t.length < minLen) return 'הטקסט קצר מדי';
  if (t.length > maxLen) return 'הטקסט ארוך מדי';
  // basic SQL injection heuristics
  const lowered = t.toLowerCase();
  const suspicious = ['--', ';', '/*', '*/', "@@", 'char(', 'nchar(', 'varchar(', 'alter ', 'drop ', 'insert ', 'delete ', 'update ', 'select '];
  for (const s of suspicious) {
    if (lowered.includes(s)) return 'השדה מכיל תווים חשודים';
  }
  return null;
}

export function validateMeetingFields(title: string, summary: string, description?: string) {
  const errs: any = {};
  const tErr = validateText(title, 1, 200);
  const sErr = validateText(summary, 1, 1000);
  const dErr = description ? validateText(description, 0, 2000) : null;
  if (tErr) errs.title = tErr;
  if (sErr) errs.summary = sErr;
  if (dErr) errs.description = dErr;
  return errs;
}

export function localizeValidationMessage(msg: string, resources: any) {
  if (!msg) return msg;
  const map: Record<string,string> = {
    'השם דרוש': 'Validation.NameRequired',
    'שם מכיל תווים לא חוקיים': 'Validation.NameInvalidChars',
    'שם מכיל תווים חשודים': 'Validation.NameSuspicious',
    'השם קצר מדי': 'Validation.NameTooShort',
    'השם ארוך מדי': 'Validation.NameTooLong',
    'אימייל דרוש': 'Validation.EmailRequired',
    'אימייל לא חוקי': 'Validation.EmailInvalid',
    'אימייל ארוך מדי': 'Validation.EmailTooLong',
    'טלפון דרוש': 'Validation.PhoneRequired',
    'טלפון צריך להכיל רק ספרות': 'Validation.PhoneDigitsOnly',
    'מספר קצר מדי, יש להכניס לפחות 10 ספרות': 'Validation.PhoneTooShort',
    'מספר ארוך מדי, יש להכניס עד 10 ספרות': 'Validation.PhoneTooLong',
    'שדה דרוש': 'Validation.FieldRequired',
    'הטקסט קצר מדי': 'Validation.TextTooShort',
    'הטקסט ארוך מדי': 'Validation.TextTooLong',
    'השדה מכיל תווים חשודים': 'Validation.FieldSuspicious'
  };
  const key = map[msg];
  try {
    if (key && resources && typeof resources.get === 'function') {
      const localized = resources.get(key, msg);
      return localized || msg;
    }
  } catch { }
  return msg;
}

// Helper to convert a validation message to localized version using resources provider
export function localizeErrors(errors: any, resources: any) {
  if (!errors) return errors;
  const out: any = {};
  for (const k of Object.keys(errors)) {
    const v = errors[k];
    out[k] = localizeValidationMessage(v, resources);
  }
  return out;
}
